import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import OtherSettingForm from './OtherSettingForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class OtherSetting extends Component {
    render() {
        const columns = [
            { label: 'สถานที่ทำงาน', align: 'left', name: 'email', search_type: 'string' },
        ];

        const api_url = '/user/internal';
        const datasource = [
            { key: 1, active: true, value: ['โรงพยาบาล A' ] },
            { key: 2, active: true, value: ['โรงพยาบาล B' ] },
            { key: 3, active: true, value: ['โรงพยาบาล C' ] },
        ];

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='สถานที่ทำงาน' program_type='ข้อมูลบัญชีผู้ใช้งาน'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable columns={columns} allow_active={true} datasource={datasource}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<OtherSettingForm {...props} url={api_url}></OtherSettingForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<OtherSettingForm {...props} url={api_url}></OtherSettingForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default OtherSetting
